<script setup lang="ts">
import {
    faArrowLeft,
    faArrowRight,
    faSliders,
} from '@fortawesome/pro-regular-svg-icons';
import { faLocationDot } from '@fortawesome/pro-solid-svg-icons';
import RealTimeLoading from './RealTimeLoading.vue';

const { haveMapButton, fixed } = defineProps<IProps>();
const emit = defineEmits<{
    nextDay: [];
    prevDay: [];
    openFilters: [];
    toggleMap: [];
}>();
const itineraryStore = useItineraryStore();
const currentModule = useCurrentItineraryModule();
interface IProps {
    fixed?: boolean;
    haveMapButton?: boolean;
}
const visible = ref(true);
const isLoading = computed(
    () =>
        currentModule.value.isRealTimeLoading &&
        !itineraryStore.allPackagesLoaded
);
const scrollToggle = () => {
    const footerEl = document.getElementById('__footer');
    visible.value =
        !!footerEl &&
        footerEl.getBoundingClientRect().y > (haveMapButton ? 116 : 56);
};
onMounted(() => window.addEventListener('scroll', scrollToggle));
onBeforeUnmount(() => window.removeEventListener('scroll', scrollToggle));
</script>

<template>
    <div
        class="price-fab-container"
        :class="{ 'fix-box': fixed, invisible: !visible, map: haveMapButton }"
    >
        <div class="actions-container">
            <mr-button
                v-if="haveMapButton"
                class="mobile-show-map-button"
                :right-icon="faLocationDot"
                @click="emit('toggleMap')"
            >
                نقشه
            </mr-button>
            <ClientOnly>
                <RealTimeLoading v-if="isLoading" in-filters />
            </ClientOnly>
            <mr-button
                v-show="!isLoading"
                size="small"
                :right-icon="faSliders"
                @click="emit('openFilters')"
            >
                فیلتر و مرتب‌سازی
            </mr-button>
            <div class="price-calendar-buttons">
                <mr-button
                    id="prev-day"
                    size="small"
                    :right-icon="faArrowRight"
                    @click="emit('prevDay')"
                >
                    روز قبل
                </mr-button>
                <mr-button
                    id="next-day"
                    size="small"
                    :left-icon="faArrowLeft"
                    @click="emit('nextDay')"
                >
                    روز بعد
                </mr-button>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
.price-fab-container {
    display: none;
    position: absolute;
    bottom: -40px;
    right: 0;
    width: 100%;
    background-color: transparent;
    height: 56px;
    padding: 0 8px 8px;
    -webkit-transform: translateZ(0);
    -ms-transform: translateZ(0);
    transform: translateZ(0);
    transition: transform 0.2s ease;
    z-index: 1000;
    &.invisible {
        transform: translateY(56px);
        &.map {
            transform: translateY(116px);
        }
    }
    &.fix-box {
        position: fixed;
        bottom: 0;
    }
    .actions-container {
        width: 100%;
        background-color: usePalette();
        border-radius: 12px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 6px 8px;
        @include shadow(2);
        .price-calendar-buttons {
            display: flex;
            flex-shrink: 0;
        }
        .mobile-show-map-button {
            position: absolute;
            top: -60px;
            left: 50%;
            transform: translateX(-50%);
            width: 94px;
        }
    }
    @include mobile-only {
        display: flex;
    }
}
</style>
